import { AxiosResponse } from 'axios';

import api from './api';

const refreshToken = (): Promise<AxiosResponse<any>> => {
  return new Promise((resolve, reject) => {
    api
      .get('auth/refresh')
      .then(async res => {
        localStorage.setItem('@cartaoluiza:token', res.data.token);
        return resolve(res);
      })
      .catch(err => {
        return reject(err);
      });
  });
};

export default refreshToken;
